import type { WPathTranslations } from "./pl";

export const de: WPathTranslations = {
  ariaLabel: "Brotkrumennavigation",
};
